// WACheckin Pay: cada PROPIETARIO de los apartamentos que lleva un gestor cobra
// en su propia cuenta, que abre la plataforma. Vive como pestaña de la pantalla
// de Stripe (PaymentAccountsProvider + WacheckinPayOwners).
export const wacheckinPay = {
  modes: {
    own: {
      title: "Mis cuentas de Stripe",
      text: "Conecta tu propia cuenta de Stripe. Ideal si cobras tú o tu empresa.",
    },
    pay: {
      badge: "NUEVO",
      text: "Para gestores: cada propietario cobra lo suyo. Tú solo le mandas un enlace.",
    },
  },
  ownerAccountName: "Propietario · {name}",

  hero: {
    title: "Cobros para tus propietarios",
    text: "Activa el cobro de cada apartamento a nombre de su propietario. El dinero de las reservas le llega directamente a su banco, sin que tenga que saber qué es Stripe.",
    step1: "Elige los apartamentos de un propietario",
    step2: "Escribe su nombre y su correo",
    step3: "Recibe un enlace, añade su IBAN y empieza a cobrar",
  },
  stats: {
    owners: "Propietarios",
    ready: "Cobrando",
    pending: "Pendientes",
    withoutOwner: "Apartamentos sin propietario",
  },

  suggest: {
    title: "Tus propietarios sin cobro activado",
    subtitle: "Ya están en tu equipo o en tu lista de Propietarios. Activa su cobro con sus datos y sus apartamentos ya rellenados.",
    apartments: "{count} apartamento | {count} apartamentos",
  },

  owners: {
    title: "Propietarios",
    subtitle: "Cada propietario tiene una sola cuenta para todos sus apartamentos.",
    new: "Nuevo propietario",
    emptyTitle: "Aún no hay propietarios",
    emptyText: "Elige abajo los apartamentos de un propietario y pulsa «Activar cobro». Le llegará un enlace para añadir sus datos y su cuenta bancaria.",
    sentAt: "enlace enviado el {date}",
    addApartments: "Añadir apartamentos",
    hasAccess: "Acceso al panel",
    removeApartment: "Quitar este apartamento",
  },

  status: {
    pendiente: "Pendiente del propietario",
    faltan_datos: "Faltan datos",
    en_revision: "En revisión",
    lista: "Cobrando",
    bloqueada: "Rechazada",
  },
  statusHint: {
    pendiente: "Todavía no ha completado sus datos. Mándale el enlace.",
    faltan_datos: "Stripe le pide algún dato más. Reenvíale el enlace para que lo complete.",
    en_revision: "Ha enviado sus datos y Stripe los está revisando. Suele tardar unos minutos.",
    bloqueada: "Stripe no ha podido verificar esta cuenta. Pasa sus apartamentos a otra cuenta.",
  },

  actions: {
    copyLink: "Copiar enlace",
    copy: "Copiar",
    sendEmail: "Enviar por correo",
    resendEmail: "Reenviar correo",
    sendWhatsapp: "Enviar por WhatsApp",
    refresh: "Comprobar estado",
    edit: "Editar propietario",
    delete: "Eliminar propietario",
  },

  apartments: {
    title: "Apartamentos",
    subtitle: "Elige quién cobra cada apartamento. Puedes seleccionar varios a la vez.",
    search: "Buscar apartamento…",
    filter: {
      all: "Todos",
      without: "Sin propietario",
      with: "Con propietario",
      pending: "Propietario pendiente",
    },
    colApartment: "Apartamento",
    colCollects: "Quién cobra",
    activate: "Activar cobro",
    change: "Cambiar",
    activateSelected: "Activar cobro para un propietario",
    assignToExisting: "Pasar a un propietario…",
    selected: "{count} apartamento seleccionado | {count} apartamentos seleccionados",
    clear: "Quitar selección",
    ownAccount: "Tu cuenta · {name}",
    ownerNotActive: "Propietario: {name} (sin activar)",
    noAccount: "Sin cuenta de cobro",
    noMatch: "Ningún apartamento coincide con la búsqueda.",
    none: "No tienes apartamentos que cobren con Stripe.",
  },

  wizard: {
    title: "Activar cobro",
    doneTitle: "¡Propietario creado!",
    stepApartments: "Apartamentos",
    stepOwner: "Propietario",
    stepLink: "Enlace",
    apartmentsLead: "¿Qué apartamentos son de este propietario? Todos cobrarán en la misma cuenta.",
    movesFrom: "ahora de {name}",
    ownerLead: "Datos del propietario de {count} apartamento. | Datos del propietario de {count} apartamentos.",
    create: "Crear y generar enlace",
    doneEmailSent: "Hemos enviado a {name} un correo a {email} con su enlace. También puedes mandárselo por WhatsApp.",
    doneNoEmail: "Manda este enlace a {name} para que añada sus datos y su cuenta bancaria.",
    linkLabel: "Enlace del propietario",
    linkHint: "No caduca: si lo deja a medias, puede volver a abrirlo y continuar.",
  },

  form: {
    giveAccess: "Darle acceso al panel como Propietario",
    giveAccessHint: "Se crea en Gestión de equipo con el rol Propietario: verá el calendario y las analíticas de sus apartamentos. Es la misma persona, no un usuario aparte.",
    alreadyMember: "{name} ya está en tu equipo como Propietario: se le añaden estos apartamentos.",
    password: "Contraseña",
    passwordConfirm: "Repite la contraseña",
    passwordShort: "La contraseña necesita al menos 8 caracteres.",
    passwordMismatch: "Las contraseñas no coinciden.",
    fromList: "Propietario de tu equipo o tu lista",
    fromListNone: "— Otro propietario (escribir sus datos) —",
    alreadyActive: "ya activado",
    name: "Nombre del propietario o empresa",
    namePh: "Ej. Juan Pérez o Inversiones Sol S.L.",
    email: "Correo",
    phone: "Teléfono (WhatsApp)",
    country: "País de su banco",
    countryHint: "Stripe no permite cambiarlo después.",
    lang: "Idioma del correo",
    sendEmail: "Enviar ahora el enlace por correo al propietario",
    privacy: "Los datos personales y bancarios los introduce el propietario directamente en Stripe. Ni tú ni WACheckin los veis.",
    nameRequired: "Escribe el nombre del propietario.",
    emailRequired: "Escribe un correo válido.",
  },

  add: {
    title: "Añadir apartamentos a {name}",
    save: "Añadir",
  },
  move: {
    title: "¿Quién cobra «{apt}» ahora?",
    lead: "Dejará de cobrarlo {name}. Elige qué cuenta lo cobra a partir de ahora.",
    target: "Pasa a cobrar en",
    toDefault: "Tu cuenta principal · {name}",
    toNone: "Ninguna cuenta (no podrá cobrar)",
    ownGroup: "Tus otras cuentas",
    ownersGroup: "Otro propietario",
    noDefaultWarn: "No tienes cuenta principal de Stripe: este apartamento no podrá cobrar hasta que lo asignes.",
    save: "Guardar",
  },
  edit: {
    title: "Editar propietario",
    note: "Cambia los datos de contacto. Los datos bancarios solo los puede cambiar el propietario en Stripe.",
    save: "Guardar",
  },
  delete: {
    title: "¿Eliminar a {name}?",
    lead: "Su cuenta deja de usarse para cobrar. Los cobros ya hechos no se tocan.",
    moveTo: "Su apartamento pasa a cobrar en: | Sus {count} apartamentos pasan a cobrar en:",
    confirm: "Eliminar",
  },

  msg: {
    copied: "Enlace copiado",
    emailSent: "Correo enviado a {email}",
    saved: "Guardado",
    deleted: "Propietario eliminado",
    error: "No se ha podido completar. Inténtalo de nuevo.",
    createError: "No se ha podido crear el propietario. Inténtalo de nuevo.",
  },

  alerts: {
    title: "Hay {count} problema con el dinero de un propietario | Hay {count} problemas con el dinero de tus propietarios",
  },
  activity: {
    button: "Movimientos",
    title: "Movimientos de {name}",
    loading: "Consultando a Stripe…",
    stripeDown: "Stripe no ha contestado ahora mismo. Se ven los avisos guardados; vuelve a intentarlo en un momento.",
    available: "Disponible",
    pending: "Pendiente de liberar",
    bankPayouts: "Pagos a su banco",
    enabled: "Activados",
    disabled: "Bloqueados",
    tabPayouts: "Transferencias al banco",
    tabPayments: "Cobros",
    tabEvents: "Avisos",
    arrivedOn: "Llegó el {date}",
    expectedOn: "Prevista para el {date}",
    sentOn: "Del {date}",
    payoutStatus: {
      paid: "Pagada",
      in_transit: "En camino",
      pending: "Pendiente",
      failed: "Fallida",
      canceled: "Cancelada",
    },
    guest: "Huésped",
    booking: "reserva #{id}",
    paid: "Cobrado",
    refunded: "Reembolsado",
    partialRefund: "Reembolso de {amount}",
    disputeLine: "Disputa de {amount}: {reason}",
    disputeStatus: {
      warning_needs_response: "Disputa: hay que responder",
      warning_under_review: "Disputa en revisión",
      warning_closed: "Disputa cerrada",
      needs_response: "Disputa: hay que responder",
      under_review: "Disputa en revisión",
      won: "Disputa ganada",
      lost: "Disputa perdida",
      prevented: "Disputa evitada",
    },
    problem: "Revisar",
    ok: "Correcto",
    noPayouts: "Todavía no hay transferencias a su banco.",
    noPayments: "Todavía no hay cobros en esta cuenta.",
    noEvents: "Sin avisos. Aquí aparecerá si una transferencia falla o un huésped abre una disputa.",
    ownerDashboard: "Panel de Stripe del propietario",
    reload: "Actualizar",
  },
  events: {
    payoutFailed: "Transferencia de {amount} fallida: {reason}",
    payoutCanceled: "Transferencia de {amount} cancelada",
    payoutPaid: "Transferencia de {amount} pagada a su banco",
    refunded: "Reembolso de {amount} a un huésped",
    disputeOpened: "Disputa abierta por {amount}: {reason}",
    disputeWon: "Disputa de {amount} ganada",
    disputeLost: "Disputa de {amount} perdida",
  },
  failure: {
    generic: "el banco la ha rechazado",
    account_closed: "la cuenta bancaria está cerrada",
    account_frozen: "la cuenta bancaria está bloqueada",
    bank_account_restricted: "la cuenta bancaria tiene restricciones",
    bank_ownership_changed: "la cuenta bancaria ha cambiado de titular",
    could_not_process: "el banco no ha podido procesarla",
    debit_not_authorized: "el banco no la ha autorizado",
    declined: "el banco la ha rechazado",
    insufficient_funds: "no hay saldo suficiente en Stripe",
    invalid_account_number: "el IBAN no es válido",
    incorrect_account_holder_name: "el titular no coincide con el de la cuenta",
    invalid_currency: "el banco no acepta esa moneda",
    no_account: "esa cuenta bancaria no existe",
    unsupported_card: "la tarjeta de destino no se admite",
  },
  disputeReason: {
    general: "motivo general",
    fraudulent: "el titular dice que no la hizo",
    duplicate: "cobro duplicado",
    product_not_received: "dice que no recibió el servicio",
    product_unacceptable: "dice que el servicio no era el acordado",
    subscription_canceled: "dice que lo había cancelado",
    credit_not_processed: "dice que no se le devolvió el dinero",
    unrecognized: "no reconoce el cobro",
  },

  whatsappText: "Hola {name} 👋 Para recibir el dinero de las reservas de tus apartamentos directamente en tu banco, completa tus datos aquí (5 minutos): {url}",

  next: "Siguiente",
  back: "Atrás",
  done: "Hecho",
  cancel: "Cancelar",
  close: "Cerrar",
};
